// extracted by mini-css-extract-plugin
export default {"arrow":"styles_arrow__dluSc","prev":"styles_prev__XzmyQ","next":"styles_next__sy1OS"};